import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { url: String };

  refresh() {
    if (!this.hasUrlValue || this.refreshing) return;

    this.refreshing = true;
    this.element.addEventListener("turbo:frame-load", () => {
      this.refreshing = false;
    }, { once: true });

    if (this.element.getAttribute("src") === this.urlValue) {
      this.element.reload();
    } else {
      this.element.setAttribute("src", this.urlValue);
    }
  }

  formSubmitted(event) {
    if (!event.detail.success) return;

    const form = event.target;
    if (form.closest("#school-dashboard-adjust-balance-quick-look")) {
      this.refresh();
    }
  }
}
